import * as React from "react";
import "./FeatureTypeSelectorPanel.css";
import {ImageLoader} from "../../../global/ImageLoader/ImageLoader";
import {LoaderIcon} from "../../../global/LoaderIcon/LoaderIcon";
import {TweenMax} from "gsap/TweenMax";
import {Back} from "gsap/EasePack";
import {IFeatureType} from "../../OverviewScreen";

export interface FeatureTypeSelectorPanelProps {
    keyString: string,
    data: IFeatureType,
    selected: boolean,
    fadeInDelay: number,
    contentPath: string,
    notifyLinkPress: (evt: any, link: string) => void;
    onOver: (evt: any, link: string) => void;
    onOut: (evt: any, link: string) => void;
}

export class FeatureTypeSelectorPanel extends React.Component<FeatureTypeSelectorPanelProps, {}> {
    state = {
        locked: true,
        imgScale: 1,
        scale: 1,
        alpha: 0,
        y: "-30px",
    };

    stateAnimationProxy: any = {
        locked: true,
        imgScale: 1,
        scale: 1,
        alpha: 0,
        y: 0,
    };

    stateAnimationProxySynchronize = () => {
        this.setState(
            this.stateAnimationProxy
        );
    };

    componentWillReceiveProps(nextProps: FeatureTypeSelectorPanelProps): void {
        if (nextProps.selected != this.props.selected) {
            const DUR: number = (nextProps.selected) ? .3 : .15;

            TweenMax.fromTo(this.stateAnimationProxy, DUR,
                {
                    imgScale: nextProps.selected ? 0.95 : 1,
                    scale: nextProps.selected ? 1.015 : 1,
                    y: '0px',
                    ease: Back.easeOut.config(1),
                    onComplete: this.stateAnimationProxySynchronize,
                    onUpdate: this.stateAnimationProxySynchronize
                }
            );
        }
    }

    componentDidMount(): void {
        TweenMax.to(this.stateAnimationProxy, .5,
            {
                locked: false,
                alpha: 1,
                y: '0px',
                delay: this.props.fadeInDelay,
                ease: Back.easeOut.config(1),
                onComplete: this.stateAnimationProxySynchronize,
                onUpdate: this.stateAnimationProxySynchronize
            }
        );
    }

    mouseEventHandler = (e: any): void => {
        if (this.state.locked) {
            return;
        }

        (e as Event).preventDefault();

        switch ((e as Event).type) {
            case "mouseover":
                TweenMax.to(
                    this.stateAnimationProxy,
                    .3,
                    {
                        scale: 1.015,
                        imgScale: 0.95,
                        ease: Back.easeOut.config(1),
                        onComplete: this.stateAnimationProxySynchronize,
                        onUpdate: this.stateAnimationProxySynchronize
                    }
                );
                break;
            case "mouseout":
                TweenMax.to(
                    this.stateAnimationProxy,
                    .15,
                    {
                        scale: 1,
                        imgScale: 1,
                        ease: Back.easeIn.config(1),
                        onComplete: this.stateAnimationProxySynchronize,
                        onUpdate: this.stateAnimationProxySynchronize
                    }
                );
                break;
            case "click":
                this.props.notifyLinkPress(e, this.props.data.$.href);
                break;
            default:
                console.log("unknown mouse event:", (e as Event).type);
        }
    };

    render() {

        TweenMax.set('.FeatureTypeSelectorPanel.' + this.props.keyString, {
            alpha: this.state.alpha,
            scale: this.state.scale,
            y: this.state.y,
        });

        TweenMax.set('.FeatureTypeSelectorPanel.' + this.props.keyString + ' img', {
            scale: this.state.imgScale,
        });

        return <div
            className={'FeatureTypeSelectorPanel ' + this.props.keyString}
            onClickCapture={this.mouseEventHandler}
            onMouseOverCapture={this.mouseEventHandler}
            onMouseOutCapture={this.mouseEventHandler}
        >
            <ImageLoader
                src={(this.props.data.img && this.props.data.img[0]) ? this.props.contentPath + this.props.data.img[0].$.src : ''}
                className={'image-loader'}>
                <img/>
                <p>Image with
                    url: {(this.props.data.img && this.props.data.img[0]) ? this.props.data.img[0].$.src : ''} not
                    found!</p>
                <LoaderIcon/>
            </ImageLoader>
            <div className={'ftsp-title'}>{this.props.data.title}</div>
            <div className={'arrow'}>
                <span>
                    <svg viewBox="0 0 11 22">
                        <polygon fill={'#000000'} points="0,0.6 10.1,11 0,21.4 0.3,22 11,11 0.3,0 "/>
                    </svg>
                </span>
            </div>
        </div>;
    }
}
